import { styled, Breakpoints } from '@vw-marketing/us-components';

export const StyledSlickContainer = styled.div`
  min-width: -moz-available;
  min-width: -webkit-fill-available;
  .slick-list,
  .slick-slider {
    width: 100%;
    position: relative;
    display: block;
  }

  .slick-slider {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .slick-slide,
  .slick-slide * {
    outline: none !important;
  }

  .slick-track {
    display: flex !important;
  }

  .slick-slide {
    display: flex !important;
    height: auto !important;
  }
`;

export const StyledSlickArrow = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: calc(100% + 1px);
  color: #001e50;
  background: #ffffff;

  & > .arrow-left {
    padding-right: 6px;
  }
  & > .arrow-right {
    padding-left: 6px;
  }
`;

export const StyledFilterSlickContainer = styled.div<any>`
  ${({ oneChildren }) => `
  min-width: -moz-available;
  min-width: -webkit-fill-available;
  overflow: hidden;
  position: relative;
  .slick-slider {
    position: relative;
    display: block;
    box-sizing: border-box;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    -webkit-tap-highlight-color: transparent;
    display: flex;
    margin-left: ${oneChildren ? '0' : '18px'};
    margin-right: 18px;
  }

  @media (min-width: ${Breakpoints.b560}px) {
    .slick-slider {
      margin-left: 18px;
    }
  }

  .slick-list {
    position: relative;
    overflow: hidden;
    display: contents;
    margin: 0;
    padding: 0;

    &:focus {
      outline: none;
    }

    &.dragging {
      cursor: pointer;
      cursor: hand;
    }
  }

  .slick-slider .slick-track,
  .slick-slider .slick-list {
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    -o-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  .slick-track {
    position: relative;
    left: 0;
    top: 0;
    display: flex;
    margin-left: 0;
    margin-right: 0;
    width: 100%;

    &:before,
    &:after {
      content: '';
      display: table;
    }

    &:after {
      clear: both;
    }

    .slick-loading & {
      visibility: hidden;
    }
  }
  .slick-slide {
    float: left;
    height: 100%;
    display: block;
    min-height: 1px;
    [dir='rtl'] & {
      float: right;
    }
    img {
      display: block;
    }
    &.slick-loading img {
      display: none;
    }

    &.dragging img {
      pointer-events: none;
    }

    .slick-initialized & {
      display: block;
    }

    .slick-loading & {
      visibility: hidden;
    }

    .slick-vertical & {
      display: block;
      height: auto;
      border: 1px solid transparent;
    }
  }

  .slick-arrow.slick-hidden {
    display: none;
  }

  .slick-arrow {
    position: absolute;
    top: -1px;
    z-index:1;
  }

  .slick-arrow.slick-prev {
    left: -19px;
  }
  .slick-arrow.slick-next {
    right: -19px;
  }
  `}
`;
